import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Monitor, Download, Clock } from 'lucide-react';
const discoveries = [{
  emoji: '🔥',
  title: 'Los 5 Países de Oro',
  desc: 'España (2 años a ciudadanía EU), Paraguay ($5k residencia), Portugal, Panamá, El Salvador.'
}, {
  emoji: '🔥',
  title: 'Checklist FBI/Apostilla',
  desc: 'Documentos críticos que salvarán tu futuro y cómo obtenerlos desde EE.UU.'
}, {
  emoji: '🔥',
  title: 'Guía Bancaria Anti-Bloqueo',
  desc: 'Mueve tus ahorros sin que Chase, BofA o Wells Fargo los congelen al salir.'
}, {
  emoji: '🔥',
  title: 'Matriz de Costos + Plan 90 Días',
  desc: 'Elige tu destino perfecto basado en tu presupuesto exacto y situación familiar.'
}, {
  emoji: '🔥',
  title: 'Auditoría de Salida',
  desc: 'Cómo preparar tu salida voluntaria sin dejar cabos sueltos legales o financieros.'
}];
const includes = [{
  icon: '✅',
  text: 'Manual Completo "Plan B Migratorio" (PDF 110+ páginas)'
}, {
  icon: '✅',
  text: 'Paso a paso desde la notificación de deportación hasta tu cédula legal'
}, {
  icon: '✅',
  text: 'Guía de inversión estratégica para residencia'
}, {
  icon: '✅',
  text: 'Directorio de trámites y contactos verificados'
}];
export function ProductContents() {
  return <section className="py-8 md:py-12 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-316">
      <div className="max-w-[800px] mx-auto" data-id="element-317">
        <div className="text-center mb-6 md:mb-10" data-id="element-318">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block mb-3 md:mb-5 relative" data-id="element-319">
            <img src="https://cdn.magicpatterns.com/uploads/3n4ds5BYVTxsq9t4FEGGRH/cover_2.png" alt="Plan B Migratorio" className="w-24 md:w-36 rounded-lg shadow-[0_0_30px_rgba(212,136,58,0.25)] border border-[var(--accent)]/30" data-id="element-320" />
          </motion.div>
          <p className="text-[var(--accent)] uppercase tracking-widest text-xs font-bold mb-1" data-id="element-321">
            La Guía Definitiva
          </p>
          <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] mb-2" data-id="element-322">
            "Plan B Migratorio"
          </h2>
          <p className="text-[var(--text-muted)] uppercase tracking-widest text-xs md:text-sm mb-3" data-id="element-323">
            Cómo Salir de EE.UU. y Reconstruir tu Vida Legalmente
          </p>
          <p className="text-base md:text-lg text-[var(--text-primary)] max-w-2xl mx-auto leading-relaxed" data-id="element-324">
            No es teoría legal aburrida.{' '}
            <strong className="text-[var(--text-heading)]" data-id="element-325">
              Es un manual de acción táctica para tu libertad.
            </strong>
          </p>
        </div>

        {/* === DEVICE MOCKUP — STRATEGIC PERSUASION BLOCK === */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative mb-8 md:mb-12" data-id="element-326">
          {/* Ambient glow behind the mockup */}
          <div className="absolute inset-0 -inset-x-4 md:-inset-x-8 -inset-y-2 md:-inset-y-4 pointer-events-none" style={{
          background: 'radial-gradient(ellipse 70% 60% at 50% 50%, rgba(212,136,58,0.08) 0%, transparent 70%)'
        }} data-id="element-327" />

          <div className="relative bg-[var(--bg-card)] border border-[var(--accent)]/20 rounded-xl md:rounded-2xl overflow-hidden shadow-[0_8px_60px_rgba(0,0,0,0.3)]" data-id="element-328">
            {/* Top accent line */}
            <div className="h-[2px] bg-gradient-to-r from-transparent via-[var(--accent)] to-transparent" data-id="element-329" />

            <div className="p-3 sm:p-4 md:p-8" data-id="element-330">
              {/* Label */}
              <div className="text-center mb-3 md:mb-5" data-id="element-331">
                <p className="text-[var(--accent)] text-[9px] md:text-[10px] font-bold tracking-[0.2em] uppercase mb-0.5 md:mb-1" data-id="element-332">
                  Así se ve por dentro
                </p>
                <h3 className="text-base sm:text-lg md:text-2xl font-serif text-[var(--text-heading)] leading-tight" data-id="element-333">
                  Módulo 1: La Auditoría de Salida
                </h3>
                <p className="text-xs md:text-sm text-[var(--text-muted)] mt-0.5 md:mt-1 italic" data-id="element-334">
                  Vista real del contenido en tablet y móvil
                </p>
              </div>

              {/* The mockup image */}
              <motion.div className="relative flex justify-center" whileInView={{
              y: [8, 0],
              opacity: [0.8, 1]
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.3
            }} data-id="element-335">
                {/* Soft reflection/glow under image */}
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[80%] h-10 md:h-16 pointer-events-none" style={{
                background: 'radial-gradient(ellipse at center, rgba(212,136,58,0.12) 0%, transparent 70%)',
                filter: 'blur(12px)'
              }} data-id="element-336" />
                <img src="https://cdn.magicpatterns.com/uploads/6zYCJL8XnRdxBW359dYgXL/digital.png" alt="Plan B Migratorio — Vista previa en tablet" className="w-full max-w-[320px] sm:max-w-[420px] md:max-w-[560px] rounded-md md:rounded-lg shadow-[0_4px_40px_rgba(0,0,0,0.4)] relative z-10" data-id="element-337" />
              </motion.div>

              {/* Device compatibility badges */}
              <div className="mt-3 md:mt-6 flex flex-wrap items-center justify-center gap-2 md:gap-5" data-id="element-338">
                {[{
                icon: Smartphone,
                label: 'Celular'
              }, {
                icon: Monitor,
                label: 'Tablet / PC'
              }, {
                icon: Download,
                label: 'Inmediata'
              }, {
                icon: Clock,
                label: '5 min/día'
              }].map((item, i) => <motion.div key={i} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.5 + i * 0.1
              }} className="flex items-center gap-1 text-[var(--text-muted)] text-[10px] md:text-xs" data-id="element-339">
                    <item.icon className="w-3 h-3 md:w-3.5 md:h-3.5 text-[var(--accent)]" data-id="element-340" />
                    <span data-id="element-341">{item.label}</span>
                  </motion.div>)}
              </div>

              {/* Persuasive microcopy */}
              <p className="text-center text-xs md:text-sm text-[var(--text-primary)] mt-3 md:mt-5 font-serif italic leading-relaxed max-w-md mx-auto" data-id="element-342">
                "Ábrelo en tu celular o tablet.{' '}
                <span className="text-[var(--accent)] font-semibold not-italic" data-id="element-343">
                  Tu mapa hacia la residencia legal.
                </span>
                "
              </p>
            </div>

            {/* Bottom accent line */}
            <div className="h-[2px] bg-gradient-to-r from-transparent via-[var(--accent)]/40 to-transparent" data-id="element-344" />
          </div>
        </motion.div>
        {/* === END DEVICE MOCKUP === */}

        {/* What each encounter includes */}
        <div className="bg-[var(--bg-elevated)] rounded-xl p-4 md:p-6 mb-5 md:mb-8 border border-[var(--border-subtle)]" data-id="element-345">
          <p className="text-[var(--text-muted)] text-xs uppercase tracking-widest text-center mb-3" data-id="element-346">
            El manual completo incluye:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3" data-id="element-347">
            {includes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 8
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex items-start gap-2 text-xs md:text-sm text-[var(--text-primary)]" data-id="element-348">
                <span className="text-sm flex-shrink-0" data-id="element-349">{item.icon}</span>
                <span data-id="element-350">{item.text}</span>
              </motion.div>)}
          </div>
        </div>

        {/* Discoveries */}
        <h3 className="text-lg md:text-xl font-serif text-[var(--text-heading)] text-center mb-4" data-id="element-351">
          Lo que vas a descubrir en esta guía:
        </h3>
        <div className="grid gap-2 md:gap-4" data-id="element-352">
          {discoveries.map((d, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-[var(--bg-elevated)] border border-[var(--border-subtle)]" data-id="element-353">
              <span className="text-lg flex-shrink-0" data-id="element-354">{d.emoji}</span>
              <div data-id="element-355">
                <p className="font-semibold text-[var(--text-heading)] text-xs md:text-sm mb-0.5" data-id="element-356">
                  {d.title}
                </p>
                <p className="text-[var(--text-muted)] text-xs md:text-sm leading-relaxed" data-id="element-357">
                  {d.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}